import { getMomentTz } from "@dexteel/mesf-core";
import type {
	UtilityConsumptionMeterGap,
	UtilityConsumptionWindow,
} from "../../shared/consumption/models/UtilityConsumption";

const moment = getMomentTz();

export const getMeterGapNote = (
	meterGaps: UtilityConsumptionMeterGap[],
	windowCode: UtilityConsumptionWindow,
): { secondary: string; tooltip: string } | null => {
	const gaps = meterGaps.filter((gap) => gap.WindowCode === windowCode);
	if (gaps.length === 0) return null;

	const meterIds = gaps.map((gap) => gap.ExternalMeterId);
	const lastReadUtc = gaps.length === 1 ? gaps[0].LatestReadTimeUtc : null;
	const since =
		lastReadUtc === null ? null : moment(lastReadUtc).format("MMM D, HH:mm");

	return {
		secondary:
			gaps.length === 1
				? `Missing ${meterIds[0]}`
				: `Missing ${gaps.length} meters`,
		tooltip: `${
			since === null
				? `${meterIds.join(", ")} did not report over the whole window`
				: `${meterIds[0]} has not reported since ${since}`
		}, so the figure is left blank instead of counted short.`,
	};
};
